export const FILTER_ON_THE_FLY_COMPARATORS = {
  targetUserId: (filterValue) => (valueToCompare) => filterValue === valueToCompare,
  // TODO: ascentFolding, maybe with asciiFolding library
  name: (filterValue) => (valueToCompare) => (
    valueToCompare.toLowerCase().includes(filterValue.toLowerCase())
  )
};

export const FILTER_SERVER_MAPPER = {
  unitId: 'grupo',
  divisionId: 'division',
  targetUserId: 'usuarioAsignadoId'
};
